import React from 'react';
import schema from '../masterData/schemas/userManagementSchemas';
import UserManagementData from '../masterData/UserManagementData';

const UserManagement = () => {
  return <UserManagementData schema={schema} />;
};

export default UserManagement;
